import React from 'react'
import { ButtonBase, Box } from '@mui/material'
import AddCircleIcon from '@mui/icons-material/AddCircle';


function PlusButton({onClick, customStyles}) {
    const buttonBaseStyles = {
        borderRadius: '50%',
        width: '25px',
        height: '25px',
        backgroundColor: '#0475DD',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        position: 'relative',
    }

    const circleIconStyles = {
        fontSize: '30px', 
        fill: '#0475DD', 
        // position: 'absolute',
    }

    const iconBackground = {
        backgroundColor: 'white',
        borderRadius: '50%',
        width: '20px',
        height: '20px',

        // center the icon (child) on top of the white circle background
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    
    }

    return (
        // Outer box to center the button
        <Box sx={{display: 'flex', justifyContent: 'center', ...customStyles}}>
            <ButtonBase onClick={onClick} sx={buttonBaseStyles}>
                <Box sx={iconBackground}>
                    <AddCircleIcon sx={circleIconStyles}/>
                </Box>
            </ButtonBase>
        </Box>
    )
}

export default PlusButton